// extracted by mini-css-extract-plugin
export var label = "_ei-2";
export var slideContainer = "_ei-0";
export var slider = "_ei-1";